module.exports = __webpack_public_path__ + "img/marquee-bg.4c5ee19.webp";